import { makeApiRequest } from '@/src/lib/api-request'
import { useMutation } from '@tanstack/react-query'

export const useVerifyPhoneMutation = () => {
  return useMutation({
    mutationKey: ['user', 'send-otp-phone'],
    mutationFn: async (data: { otp: string }) => {
      await makeApiRequest({
        method: 'POST',
        url: '/Login/otpValidate',
        data: {
          otp: data.otp,
        },
        isAuthenticated: true,
        fallbackError: 'Error while sending verification code',
        isV3Api:true
      })
    },
  })
}
